import {Component, Input, OnInit} from '@angular/core';
import {AbstractValueAccessor, MakeAccessor} from '../abstract-value-accessor';
import {FormControl} from '@angular/forms';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'nf-date-time',
  templateUrl: './date-time.component.html',
  styleUrls: ['./date-time.component.css'],
  providers: [MakeAccessor(DateTimeComponent), DatePipe]
})
export class DateTimeComponent extends AbstractValueAccessor implements OnInit {

  dateTime;
  tempData;
  open = false;
  format = 'yyyy-MM-dd';
  @Input() disabled = false;
  constructor(
    private datePipe: DatePipe
  ) {
    super();
  }

  ngOnInit() {
    this.localValidateForm.addControl('date', new FormControl());
    this.localValidateForm.addControl('time', new FormControl());
  }

  closePop() {
    if (this.tempData) {
      this.dateTime = JSON.parse(this.tempData);
    } else {
      this.dateTime = null;
    }
    this.open = false;
  }

  commitData() {
    this.open = false;
    // 如果数据没变，则不提交
    if (this.tempData === JSON.stringify(this.dateTime)) {
      return;
    } else {
      this.tempData = JSON.stringify(this.dateTime);
    }
    if (this.dateTime) {
      this.localValidateForm.patchValue({
        date: this.datePipe.transform(this.dateTime, 'yyyy-MM-dd'),
        time: this.datePipe.transform(this.dateTime, 'HH:mm')
      });
    } else {
      this.localValidateForm.setValue({
        date: null,
        time: null
      });
    }
  }

  writeValue(obj: any): void {
    if (obj) {
      this.localValidateForm.patchValue(obj, {emitEvent: false});
      if (obj['date']) {
        this.dateTime = new Date(obj['date'] + ' ' + obj['time']);
      }
      this.tempData = JSON.stringify(this.dateTime);
    }
  }
}
